import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import Button from './Button';

export default function Modal({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  size = 'md',
  onConfirm,
  confirmLabel = 'Confirm',
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const widthCls = { sm: 'max-w-md', md: 'max-w-2xl', lg: 'max-w-4xl', xl: 'max-w-6xl' }[size] || 'max-w-2xl';

  return (
    <div
      className="fixed inset-0 bg-neutral-900/40 backdrop-blur-sm z-[100] flex items-center justify-center p-4"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className={`bg-white rounded-2xl shadow-2xl w-full ${widthCls} overflow-hidden border border-white/20 max-h-[90vh] flex flex-col`}>
        <div className="px-6 py-5 border-b border-neutral-100 flex justify-between items-center bg-white shrink-0">
          <div>
            <h3 className="font-bold text-lg text-neutral-900">{title}</h3>
            {subtitle && <p className="text-xs text-neutral-500 mt-1">{subtitle}</p>}
          </div>
          <button onClick={onClose} className="text-neutral-400 hover:text-neutral-700">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto">{children}</div>
        {footer !== null && (
          <div className="px-6 py-5 bg-neutral-50 flex justify-end gap-3 border-t border-neutral-100 shrink-0">
            {footer || (
              <>
                <Button variant="ghost" onClick={onClose}>Cancel</Button>
                {onConfirm && (
                  <Button variant="primary" onClick={onConfirm}>{confirmLabel}</Button>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
